import { render, staticRenderFns } from "./EventCall.vue?vue&type=template&id=65daa3c4&scoped=true"
import script from "./EventCall.vue?vue&type=script&lang=js"
export * from "./EventCall.vue?vue&type=script&lang=js"
import style0 from "./EventCall.vue?vue&type=style&index=0&id=65daa3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65daa3c4",
  null
  
)

export default component.exports